import ApiService from './ApiService.js'

export default {
  get (id, params = {}) {
    return ApiService.get('crops', id, params)
  },

  find (params, subresource = '') {
    return ApiService.get('crops', subresource, params)
  },

  pdf (id, locale = 'de', params) {
    return ApiService.get('crops', `${id}/pdf/${locale}`, params)
  },

  put (payload, slug = []) {
    return ApiService.put('crops', slug, { payload })
  },

  post (payload) {
    return ApiService.post('crops', { payload })
  },

  trash (id) {
    return ApiService.trash('crops', id)
  },

  untrash (id) {
    return ApiService.untrash('crops', id)
  },

  delete (id) {
    return ApiService.delete('crops', id)
  }
}
